<div mat-dialog-title class="!text-base !flex items-center">
    {{title}}
    <span class="flex-1"></span>
</div>
<div mat-dialog-content class="py-0">
    <form [formGroup]="myForm" *ngIf="addPermission" (ngSubmit)="onSubmit()">
        <div class="grid gap-y-2">
            <mat-form-field class="w-full">
                <mat-label>Plataforma</mat-label>
                <mat-select formControlName="platform" (selectionChange)="onChangeSelect()">
                    <mat-option *ngFor="let p of platforms" [value]="p.id">
                        {{p.plataforma_clasificacion.plataforma.descripcion}} >
                        {{p.plataforma_clasificacion.descripcion}}: {{p.valor}}
                    </mat-option>
                </mat-select>
                <mat-error>
                    Completa este campo.
                </mat-error>
            </mat-form-field>

            <!-- Tipo de valorización -->
            <div *ngIf="myForm.get('platform').value" class="font-bold text-black mb-[14px]">
                <span class="font-bold">Tipo de valorización:</span>
                <span *ngIf="!tipoValorizacion">Normal</span>
                <span *ngIf="tipoValorizacion === 'tiempo'">Por segundo</span>
                <span *ngIf="tipoValorizacion === 'impreso'">Por cm²</span>
            </div>

            <div class="grid sm:grid-cols-2 gap-x-4 gap-y-2">
                <mat-form-field class="w-full">
                    <mat-label>Valor($)</mat-label>
                    <input matInput type="number" formControlName="value">
                    <mat-error>
                        Completa este campo.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Alcance</mat-label>
                    <input matInput type="number" formControlName="alcance">
                    <mat-error>
                        Completa este campo.
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Alerta para Radio y Televisión -->
            <div *ngIf="tipoValorizacion === 'tiempo'"
                class="flex items-start gap-3 rounded border border-yellow-300 bg-yellow-50 px-4 py-3 text-sm text-yellow-900 mt-2">
                <mat-icon class="!text-yellow-600 shrink-0 mt-0.5 icon-alert" >warning</mat-icon>
                <span>
                    Recuerda que la valorización en US$ que coloques se multiplicará por cada segundo de
                    duración al crear tu impacto en tu detalle de plan de medios.
                </span>
            </div>

            <!-- Alerta para Impreso -->
            <div *ngIf="tipoValorizacion === 'impreso'"
                class="flex items-start gap-3 rounded border border-yellow-300 bg-yellow-50 px-4 py-3 text-sm text-yellow-900 mt-2">
                <mat-icon class="!text-yellow-600 shrink-0 mt-0.5 icon-alert" >warning</mat-icon>
                <span>
                    Recuerda que la valorización que coloques se multiplicará por cada cm<sup>2</sup> de hoja
                    impresa al crear tu impacto en tu detalle de plan de medios.
                </span>
            </div>
        </div>
    </form>    

    <div *ngIf="this.data.row"
        class="flex items-start gap-3 rounded border border-yellow-300 bg-yellow-50 px-4 py-3 text-sm text-yellow-900 mt-2 mb-2">
        <mat-icon class="!text-yellow-600 shrink-0 mt-0.5 icon-alert">warning</mat-icon>
        <span *ngIf="userIsAgent">
            Recuerda que estos valores solo aplicarán para los impactos que se crearán de aquí en adelante. Si deseas modificar el alcance y/o valorización de impactos ya creados, solicítalo a tu supervisor.
        </span>
        <span *ngIf="userIsAdmin">
            Si deseas modificar el alcance y/o valorización de impactos ya creados, haz clic en <span class="font-bold">Editar publicado</span> en tu detalle de plan de medios.
        </span>
    </div>
</div>

<div mat-dialog-actions align="end" class="!px-6 !mt-4">
    <button mat-stroked-button color="primary" class="me-4" mat-dialog-close type="button">Cancelar</button>
    <adp-button-icon (clicked)="onSubmit()" color="primary" [loading]="!buttonSubmit" [disabled]="myForm.invalid" label="Guardar" ></adp-button-icon>
</div>